/**
 * @generated SignedSource<<34e70da31e85e45517100be41f441ddf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FallbackCell$data = {
  readonly id?: string;
  readonly renderedFieldHtml: string | null | undefined;
  readonly type: string;
  readonly " $fragmentType": "FallbackCell";
};
export type FallbackCell$key = {
  readonly " $data"?: FallbackCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"FallbackCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "FallbackCell",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "renderedFieldHtml"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    }
  ],
  "type": "JiraFallbackField"
};

(node as any).hash = "227b4ecdf881fcd57efd6a7593756613";

export default node;
